<template>
    <div>
        <div class="content-wrapper">
            <section class="content-header">
                <h1>
                    Vérification des compétiteurs
                    <small></small>
                </h1>
                <ol class="breadcrumb">
                    <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
                    <li class="active"><a href="#">Vérification des compétiteurs</a></li>
                </ol>
            </section>

            <section class="content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="nav-tabs-custom nav-tabs-custom-bottom">
                            <ul class="nav nav-tabs" role="tablist">
                                <li :class="active==1 ? 'active' : '' ">
                                    <a href="#member_tab_1"
                                       aria-controls="#member_tab_1"
                                       data-toggle="tab"
                                       @click="active=1"

                                       aria-expanded="false">Martial Events</a>
                                </li>
<!--                                <li :class="active==2 ? 'active' : '' ">-->
<!--                                    <a href="#member_tab_2"-->
<!--                                       aria-controls="#member_tab_2"-->
<!--                                       data-toggle="tab"-->
<!--                                       @click="active=2"-->
<!--                                       aria-expanded="false">Statistiques pour les comités</a>-->
<!--                                </li>-->

                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row tab-content">
                    <div role="tabpanel" :class="active==1 ? 'active' : '' " class="col-md-12 tab-pane " id="member_tab_1">
                        <MartialEvents></MartialEvents>
                    </div>

                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import MartialEvents from './Martial_Events'

    export default {
        data() {
            return {
                loading: false,
                active: 1
            }
        },
        props: {},
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
            })
        },
        methods: {
            ...mapActions({
            }),

        },

        watch: {},
        components: {
            MartialEvents: MartialEvents,
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Verification/AppVerification.vue